function Loader() {
  return <div style={{fontSize:'1.5rem', marginTop:'46vh',textAlign:'center', height:'30vh'}}>🌀 Loading...</div>;
}

export default Loader
